<div class="fill-panel" (click)="dropDownClick()">
  <div class="container">
    <nw-color-selector
      [color]="currentColor"
      label="fill"
      (colorChange)="updateColor($event)"
      [dark]="true"
    ></nw-color-selector>
  </div>
</div>
